// extracted by mini-css-extract-plugin
module.exports = {"toggleableLegend":"style-module_toggleableLegend__29xPcpF6fhfM_Pm5dY426f","loading":"style-module_loading__1kxzj6BnfZu0zaN5I2Tdhu"};